<template>
  <div>
    <Categories
      v-if="hasPermission('maintenanceSchedules.categories.view')"
      class="mb-2"
    />
    <Frequencies
      v-if="hasPermission('maintenanceSchedules.frequencies.view')"
      class="mb-2"
    />
    <Activities v-if="hasPermission('maintenanceSchedules.activities.view')" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Categories from '@/views/admin/configuration/maintenanceSchedule/Categories';
import Frequencies from '@/views/admin/configuration/maintenanceSchedule/Frequencies';
import Activities from '@/views/admin/configuration/maintenanceSchedule/Activities';

export default {
    components: {
        Categories,
        Frequencies,
        Activities,
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ]),
    },
};
</script>
